import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaTextAreaModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class HelpMetaModel extends FormMetaModel {
    constructor() {
        super('Help', "" , ROUTE_PATH.help, 1);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const content = new SmMetaTextAreaModel(
            'content',
            'content',
            'SimpleTextarea',
            false,
            '',
            1,
            1,
            'Content',
            'textarea',
            '',
            true,
            true,
            true,
            false,
            250,
            5
        );
        const buttons = {
            submit: new SmBtnMetaModel('Submit', '', true, false, true, true),
            isFormControl: false
        };

        return {
            formInfo,
            content,
            buttons
        };
    }
}


